<script>
import { mapActions, mapState } from 'vuex';
import { cloneDeep } from 'lodash-es';
import transportIndex from '../../variables/transportIndexes';
import NonDynamicTransportTypes from '../../components/non-dynamic-transport/NonDynamicTransportTypes';
import NonDynamicTransportAllotmentTypes
  from '../../components/non-dynamic-transport/NonDynamicTransportAllotmentTypes';
import NonDynamicTransportSuppliers from '../../components/non-dynamic-transport/NonDynamicTransportSuppliers';
import NonDynamicTransportAllotments from '../../components/non-dynamic-transport/NonDynamicTransportAllotments';
import NonDynamicTransportTrip from '../../components/non-dynamic-transport/NonDynamicTransportTrip';
import NonDynamicTransportAges from '../../components/non-dynamic-transport/NonDynamicTransportAges';
import NonDynamicTransportUpload from '../../components/non-dynamic-transport/NonDynamicTransportUpload';
import NonDynamicTransportLuggage from '../../components/non-dynamic-transport/NonDynamicTransportLuggage';
import NonDynamicTransportItineraries from '../../components/non-dynamic-transport/NonDynamicTransportItineraries';

export default {
  name: 'NonDynamicTransportWrapper',
  components: {
    NonDynamicTransportTypes,
    NonDynamicTransportAllotmentTypes,
    NonDynamicTransportSuppliers,
    NonDynamicTransportAllotments,
    NonDynamicTransportTrip,
    NonDynamicTransportAges,
    NonDynamicTransportUpload,
    NonDynamicTransportLuggage,
    NonDynamicTransportItineraries,
  },
  props: {
    transport: {
      type: Object,
      default: null,
    },
    defaultTransport: {
      type: Object,
      required: true,
    },
    defaultTrip: {
      type: Object,
      required: true,
    },
    defaultTripSeating: {
      type: Object,
      required: true,
    },
    defaultTripConsumables: {
      type: Object,
      required: true,
    },
    defaultTripUpgrade: {
      type: Object,
      required: true,
    },
    defaultLuggage: {
      type: Object,
      required: true,
    },
    siblingCreated: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      localTransport: null,
      outBoundTitle: this.$t('nonDynamicTransport.titles.outbound'),
      inBoundTitle: this.$t('nonDynamicTransport.titles.inbound'),
      showOutBound: true,
      showInBound: true,
      showTransportTypes: true,
      baseTransportIndex: transportIndex.BASE_TRANSPORT_INDEX,
      siblingTransportIndex: transportIndex.SIBLING_TRANSPORT_INDEX,
    };
  },
  computed: {
    ...mapState({
      suppliers: state => state.nonDynamicTransport.suppliers.items,
      suppliersLoading: state => state.nonDynamicTransport.suppliers.loading,
      transits: state => state.nonDynamicTransport.transits.items,
      transitsLoading: state => state.nonDynamicTransport.transits.loading,
      carriers: state => state.nonDynamicTransport.carriers.items,
      carriersLoading: state => state.nonDynamicTransport.carriers.loading,
      contractLoading: state => state.nonDynamicTransport.contractUpload.loading,
      itinerariesLoading: state => state.nonDynamicTransport.transportItineraries.loading,
      tripSeatingSectionTypes: state => state.nonDynamicTransport.seatingSectionTypes.items,
      seatingSectionTypesLoading: state => state.nonDynamicTransport.seatingSectionTypes.loading,
      tripConsumableTypes: state => state.nonDynamicTransport.consumableTypes.items,
      tripConsumableTypesLoading: state => state.nonDynamicTransport.consumableTypes.loading,
      tripUpgradeTypes: state => state.nonDynamicTransport.upgradeTypes.items,
      tripUpgradeTypesLoading: state => state.nonDynamicTransport.upgradeTypes.loading,
      luggageTypes: state => state.nonDynamicTransport.luggageTypes.items,
      luggageTypesLoading: state => state.nonDynamicTransport.luggageTypes.loading,
      transportLuggage: state => state.nonDynamicTransport.transportLuggage.items,
      transportLuggageLoading: state => state.nonDynamicTransport.transportLuggage.loading,
      contracts: state => state.nonDynamicTransport.contracts.items,
    }),
    initialLoad() {
      return !(!this.transitsLoading &&
        !this.carriersLoading &&
        !this.seatingSectionTypesLoading &&
        !this.tripConsumableTypesLoading &&
        !this.tripUpgradeTypesLoading &&
        !this.luggageTypesLoading
      );
    },
  },
  methods: {
    ...mapActions({
      getSuppliers: 'nonDynamicTransport/getSuppliersWithCurrency',
      getTransits: 'nonDynamicTransport/getTransitsByType',
      getCarriers: 'nonDynamicTransport/getCarriers',
      uploadContracts: 'nonDynamicTransport/uploadContracts',
      getTransportTripSeatingSectionTypes: 'nonDynamicTransport/getTransportTripSeatingSectionTypes',
      getTransportTripConsumableTypes: 'nonDynamicTransport/getTransportTripConsumableTypes',
      getTransportTripUpgradeTypes: 'nonDynamicTransport/getTransportTripUpgradeTypes',
      getTransportLuggageTypes: 'nonDynamicTransport/getTransportLuggageTypes',
      getTransportContractsByTransportId: 'nonDynamicTransport/getTransportContractsByTransportId',
      getTransportLuggage: 'nonDynamicTransport/getTransportLuggage',
      deleteTransport: 'nonDynamicTransport/deleteTransport',
    }),
    setTransportType(transportType) {
      this.localTransport.type = transportType;
    },
    setAllotmentType(allotmentType) {
      this.localTransport.allotment = allotmentType;
    },
    setSupplier(supplierId) {
      this.localTransport.supplierId = supplierId;
    },
    setTicketHandling(ticketHandling) {
      this.localTransport.ticketHandling = ticketHandling;
    },
    setAllotments(allotments) {
      this.localTransport.allotments = allotments;
    },
    setOutBound(trips) {
      this.localTransport.outbound = trips;
    },
    setInBound(trips) {
      this.localTransport.inbound = trips;
    },
    setAges(ages) {
      this.localTransport.ages = ages;
    },
    saveTransport() {
      this.$emit('save', { index: this.index, transport: this.localTransport });
    },
    createTransport() {
      if (!this.transport) {
        this.localTransport = cloneDeep(this.defaultTransport);
      } else {
        this.localTransport = cloneDeep(this.transport);
      }
    },
    upload(event) {
      const contracts = { transportId: this.localTransport.id, contracts: [...event] };
      this.uploadContracts(contracts)
        .then(() => {
          this.getTransportContractsByTransportId(this.localTransport.id);
        });
    },
    deleteNDT() {
      if (confirm('Are you sure, you want to delete transport?')) {
        this.deleteTransport(this.localTransport.id);
      }
    },
  },
  watch: {
    localTransport: {
      handler(value) {
        this.$emit('update', { index: this.index, value });
      },
      deep: true,
    },
    transport(value) {
      this.localTransport = value;
    },
    siblingCreated: {
      handler(value) {
        if (value && this.index === this.baseTransportIndex) {
          this.showInBound = false;
        } else if (!value && this.index === this.baseTransportIndex) {
          this.showInBound = true;
        }
      },
    },
  },
  created() {
    if (this.index === this.siblingTransportIndex) {
      this.showOutBound = false;
      this.showTransportTypes = false;
      this.showInBound = true;
    }
    this.createTransport();

    if (this.localTransport.id) {
      this.getTransportContractsByTransportId(this.localTransport.id);
      this.getTransportLuggage(this.localTransport.id);
    }

    this.getSuppliers();
    this.getTransits();
    this.getCarriers();
    this.getTransportTripSeatingSectionTypes();
    this.getTransportTripConsumableTypes();
    this.getTransportTripUpgradeTypes();
    this.getTransportLuggageTypes();
  },
};
</script>

<template>
  <div>
    <v-progress-linear
      v-if="initialLoad"
      indeterminate
    />
    <v-card class="pa-2 mb-2" v-else>
      <v-layout row justify-end>
        <v-flex xs11>
          <non-dynamic-transport-types
            v-if="showTransportTypes"
            :transport-type="transport.type"
            @set-transport-type="setTransportType"
          />
          <non-dynamic-transport-allotment-types
            :allotment-type="transport.allotment"
            @update="setAllotmentType"
          />
        </v-flex>
        <v-flex>
          <non-dynamic-transport-upload
            v-if="!index"
            :transport-id="localTransport.id"
            :loading="contractLoading"
            :contracts="contracts"
            @upload="upload"
          />
        </v-flex>
        <v-flex>
          <non-dynamic-transport-itineraries
            v-if="!index"
            :transport-id="localTransport.id"
            :loading="itinerariesLoading"
            :itinerary-ids="localTransport.itineraryIds"
            @upload="upload"
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs11>
          <non-dynamic-transport-suppliers
            :suppliers="suppliers"
            :ticket-handling="localTransport.ticketHandling"
            :supplier-id="localTransport.supplierId"
            @set-supplier="setSupplier"
            @set-ticket-handling="setTicketHandling"
          />
        </v-flex>
        <v-flex>
          <non-dynamic-transport-luggage
            v-if="!luggageTypesLoading"
            :transport-id="localTransport.id"
            :default-luggage="defaultLuggage"
            :transport-luggage="transportLuggage"
            :luggage-types="luggageTypes"
            :loading="transportLuggageLoading"
          />
        </v-flex>
      </v-layout>
      <non-dynamic-transport-trip
        v-if="showOutBound"
        :trips="localTransport.outbound"
        :transits="transits"
        :carriers="carriers"
        :title="outBoundTitle"
        :trip-upgrade-types="tripUpgradeTypes"
        :trip-consumable-types="tripConsumableTypes"
        :trip-seating-section-types="tripSeatingSectionTypes"
        :default-trip="defaultTrip"
        :default-trip-seating="defaultTripSeating"
        :default-trip-consumables="defaultTripConsumables"
        :default-trip-upgrade="defaultTripUpgrade"
        @update="setOutBound"
      />
      <non-dynamic-transport-trip
        v-if="showInBound"
        :trips="localTransport.inbound"
        :transits="transits"
        :carriers="carriers"
        :title="inBoundTitle"
        :trip-upgrade-types="tripUpgradeTypes"
        :trip-consumable-types="tripConsumableTypes"
        :trip-seating-section-types="tripSeatingSectionTypes"
        :default-trip="defaultTrip"
        :default-trip-seating="defaultTripSeating"
        :default-trip-consumables="defaultTripConsumables"
        :default-trip-upgrade="defaultTripUpgrade"
        @update="setInBound"
      />
      <non-dynamic-transport-ages
        :ages="localTransport.ages"
        @update="setAges"
      />
      <v-divider class="mb-2 mt-2"/>
      <non-dynamic-transport-allotments
        :allotments="localTransport.allotments"
        @update="setAllotments"
      />
      <v-btn
        color="success"
        @click="saveTransport"
      >
        {{ $t('buttons.save') }}
      </v-btn>
      <v-btn
        color="warning"
        @click="deleteNDT"
      >
        {{ $t('buttons.delete') }}
      </v-btn>
    </v-card>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportWrapper.vue